<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import show from "@core/assets/icons/add.svg?raw";
	import hide from "@core/assets/icons/remove.svg?raw";
	import Icon from "./common/Icon.svelte";

	const { question, answer }: { question: string; answer: string } = $props();
	let open = $state(false);
</script>

<div
	class="bg-white flex flex-col gap-2 pt-4 pb-2 lg:pt-11 lg:pb-9 transition-colors duration-300 first:rounded-t-[1.25rem] last:rounded-b-[1.25rem] max-w-3xl lg:max-w-4xl"
>
	<div
		role="button"
		tabindex="0"
		onkeydown={(event: KeyboardEvent): void => {
			if (event.key === "Enter") {
				open = !open;
			}
		}}
		onclick={(): void => {
			open = !open;
		}}
		class="group flex w-full items-center justify-between gap-6 lg:gap-16 px-4 lg:px-10"
	>
		<h2 class={["text-md lg:text-2md text-secondary m-0 w-full text-start font-semibold", open && "text-fstgreen"]}>
			<Formatted text={question} />
		</h2>
		<div
			class="bg-fstlight-100 h-10 aspect-square rounded-full flex justify-center transition-colors group-hover:bg-fstgreen"
		>
			<Icon
				icon={open ? hide : show}
				class="text-fstgrey-200 self-center transition-colors duration-300 group-hover:text-white"
			/>
		</div>
	</div>
	<div class={["grid transition-all duration-300 overflow-clip", open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"]}>
		<div
			class={{
				"w-full min-h-0 pl-4 lg:pl-10 pr-4 sm:pr-20 lg:pr-24 transition-all": true,
				"pb-2": open,
			}}
		>
			<p class="mb-0 text-p text-left"><Formatted text={answer} /></p>
		</div>
	</div>
</div>
